import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../store/authStore';

function Header() {
  const { user, isAuthenticated, login, logout } = useAuth();

  return (
    <header className="header">
      <Link to="/" className="navbar-brand">
        Admin Console
      </Link>
      {isAuthenticated && (
        <nav>
          <NavLink to="/" end>
            Dashboard
          </NavLink>
          <NavLink to="/users">Users</NavLink>
          <NavLink to="/products">Products</NavLink>
          <NavLink to="/orders">Orders</NavLink>
          <NavLink to="/analytics">Analytics</NavLink>
          <NavLink to="/vouchers">Vouchers</NavLink>
          <NavLink to="/settings">Settings</NavLink>
        </nav>
      )}
      <div className="header-right">
        {isAuthenticated && user ? (
          <>
            <span className="user-name">{user.name || user.email}</span>
            <button type="button" className="logout-btn" onClick={logout}>
              Logout
            </button>
          </>
        ) : (
          <button type="button" className="login-btn" onClick={login}>
            Login
          </button>
        )}
      </div>
    </header>
  );
}

export default Header;
